<template>
  <div
    :class="{ fullscreen: fullscreen }"
    class="tinymce-container"
    :style="{ width: containerWidth }"
  >
    <textarea :id="tinymceId" class="tinymce-textarea" />
    <div class="editor-custom-btn-container">
    </div>
  </div>
</template>

<script>
// import plugins from './plugins'
import toolbar from "./toolbar";
import load from "./dynamicLoadScript";
import { file } from "@/api/files";

// why use this cdn, detail see https://github.com/PanJiaChen/tinymce-all-in-one
const tinymceCDN = 'https://cdn.jsdelivr.net/npm/tinymce-all-in-one@4.9.3/tinymce.min.js'
import TC from './tc'
export default {
  name: "Tinymce",
  props: {
    id: {
      type: String,
      default: function () {
        return (
          "vue-tinymce-" +
          +new Date() +
          ((Math.random() * 1000).toFixed(0) + "")
        );
      },
    },
    value: {
      type: String,
      default: "",
    },
    toolbar: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    menubar: {
      type: String,
      default: "file edit insert view format table",
    },
    height: {
      type: [Number, String],
      required: false,
      default: 360,
    },
    width: {
      type: [Number, String],
      required: false,
      default: "auto",
    },
  },
  data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        en: "en",
        zh: "zh_CN",
        tw: "zh_TW",
        es: "es_MX",
        ja: "ja",
      },
    };
  },
  computed: {
    containerWidth() {
      const width = this.width;
      if (/^[\d]+(\.[\d]+)?$/.test(width)) {
        // matches `100`, `'100'`
        return `${width}px`;
      }
      return width;
    },
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() =>
          window.tinymce.get(this.tinymceId).setContent(val || "")
        );
      }
    },
  },
  mounted() {
    this.init();
  },
  activated() {
    if (window.tinymce) {
      this.initTinymce();
    }
  },
  deactivated() {
    this.destroyTinymce();
  },
  destroyed() {
    this.destroyTinymce();
  },
  methods: {
    init() {
      load(tinymceCDN, (err) => {
        if (err) {
          this.$message.error(err.message);
          return;
        }
        this.initTinymce();
      });
    },
    initTinymce() {
      const _this = this;
      window.tinymce.addI18n('zh_CN', TC)
      window.tinymce.init({
        selector: `#${this.tinymceId}`,
        language: 'zh_CN',
        height: this.height,
        body_class: "panel-body ",
        object_resizing: false,
        toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
        menubar: "",
        plugins: "code table image",
        end_container_on_empty_block: true,
        powerpaste_word_import: "clean",
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: "square",
        advlist_number_styles: "default",
        imagetools_cors_hosts: ["www.tinymce.com", "codepen.io"],
        default_link_target: "_blank",
        link_title: false,
        nonbreaking_force_tab: true, // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
        forced_root_block: "",
        fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
        images_upload_handler: function(blobInfo, succFun) {
          let formData = new FormData();
          formData.append('file', blobInfo.blob());

          file('/files', formData)
            .then((v) => {
              // 移除域名
              let url = v.data.replace(/(?:https?:\/\/)?([a-zA-Z0-9-]+\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,})/g, '')
              // console.log(url)
              succFun(url)
            })
        },
        init_instance_callback: (editor) => {
          if (_this.value) {
            editor.setContent(_this.value);
          }
          _this.hasInit = true;
          editor.on("NodeChange Change KeyUp SetContent", () => {
            this.hasChange = true;
            this.$emit("input", editor.getContent());
          });
        },
        setup(editor) {
          function inserChi() {
            var html = "$\\chi$";
            editor.insertContent(html);
          }
          function inserPi() {
            editor.insertContent("$\\pi$");
          }
          function inserOver() {
            editor.insertContent("$\\frac{x}{y}$");
          }
          function inserMeasuredangle() {
            editor.insertContent("$\\angle$");
          }

          function inserBrackets() {
            editor.insertContent("$\\left( X \\right)$");
          }

          function onHelpBtnClick() {
            window.open("https://oysz2016.github.io/post/8611e6fb.html");
          }
          editor.addButton("addBrackets", {
            text: "( )",
            onClick: inserBrackets,
          });
          editor.addButton("addChiBtn", {
            text: "Chi",
            onClick: inserChi,
          });
          editor.addButton("addPiBtn", {
            text: "Pi",
            onClick: inserPi,
          });
          editor.addButton("addOverBtn", {
            icon: "line",
            tooltip: "插入分數",
            onClick: inserOver,
          });
          editor.addButton("addMeasuredangleBtn", {
            text: "∠",
            tooltip: "角",
            onClick: inserMeasuredangle,
          });
          editor.addButton("addMultiplicationBtn", {
            text: "×",
            tooltip: "乘法符号",
            onClick: () => {
              editor.insertContent("&times;");
            },
          });

          editor.addButton("addDivideBtn", {
            text: "÷",
            tooltip: "除法符号",
            onClick: () => {
              editor.insertContent("&divide;");
            },
          });
// Add plus button
          editor.addButton("addPlusBtn", {
            text: "+",
            tooltip: "加号",
            onClick: () => {
              editor.insertContent("+");
            },
          });

// Add minus button
          editor.addButton("addMinusBtn", {
            text: "-",
            tooltip: "减号",
            onClick: () => {
              editor.insertContent("&minus;");
            },
          });
          // Add 分數 button
          editor.addButton("addFractionBtn", {
            text: "分數",
            tooltip: "分數",
            onClick: () => {
              editor.insertContent("$\\dfrac{1}{2}$");
            },
          });
          // Add 變數 button
          editor.addButton("addVariableBtn", {
            text: "變數",
            tooltip: "變數",
            onClick: () => {
              editor.insertContent("&&{A} + {B} = {C}|C=A+B,A=1~2;B=1~2;C=#|&&");
            },
          });
          editor.addButton("addAsympBtn", {
            text: "≈",
            tooltip: "约等符号",
            onClick: () => {
              editor.insertContent("&asymp;");
            },
          });
          editor.addButton("addHelpBtn", {
            icon: "help",
            tooltip: "幫助",
            onClick: onHelpBtnClick,
          });

          editor.on("FullscreenStateChanged", (e) => {
            _this.fullscreen = e.state;
          });
        },
        convert_urls: true,
      });
    },
    destroyTinymce() {
      const tinymce = window.tinymce.get(this.tinymceId);
      if (this.fullscreen) {
        tinymce.execCommand("mceFullScreen");
      }

      if (tinymce) {
        tinymce.destroy();
      }
    },
    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent();
    },
  },
};
</script>

<style lang="scss" scoped>
.tinymce-container {
  position: relative;
  line-height: normal;
}

.tinymce-container {
  ::v-deep {
    .mce-fullscreen {
      z-index: 10000;
    }
  }
}

.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}

.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
}

.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}

.editor-upload-btn {
  display: inline-block;
}
</style>
